export default function getCreatorsNames(creators) {
  if (
    !creators?.find((creator) => {
      return creator?.name
    })
  ) {
    return null
  }

  const creatorsNames = creators?.map((creator) => {
    if (creator?.name) {
      return creator.name
    }
    return null
  })
  return creatorsNames.join(', ')
}
